import { useContext } from 'react'
import { BreakpointContext } from './context'

export const useBreakpoint = () => {
  return useContext(BreakpointContext)
}
